import * as React from 'react';
import Box from '@mui/material/Box';
import { ExclamationDiamond } from 'react-bootstrap-icons';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

export default function Error({ message, fullWidth = false }) {
	const [open, setOpen] = React.useState(true);

	return (
		<Box
			sx={{
				width: '100%',
			}}
		>
			<Collapse in={open} unmountOnExit>
				<Alert
					icon={<ExclamationDiamond />}
					severity="error"
					action={
						<IconButton
							aria-label="close"
							role="button"
							aria-hidden="false"
							color="inherit"
							size="small"
							onClick={() => {
								setOpen(false);
							}}
						>
							<CloseIcon
								fontSize="inherit"
								aria-label="close"
								role="graphics-symbol"
								aria-hidden="true"
							/>
						</IconButton>
					}
					sx={{
						width: fullWidth ? '100%' : '450px',
						maxWidth: '100%',
						marginLeft: '0',
					}}
				>
					{message}
				</Alert>
			</Collapse>
		</Box>
	);
}
Error.propTypes = {
	message: PropTypes.string,
	fullWidth: PropTypes.bool,
};
